import React from "react";
import { BackArrowIcon } from "components/icons/icons";
import IconButton from "components/iconButton/iconButton";

type CommonProps = Partial<React.ButtonHTMLAttributes<HTMLButtonElement>> &
  Partial<React.LinkHTMLAttributes<Omit<HTMLAnchorElement, "href">>>;

type ButtonBackProps = CommonProps & {
  children: string | React.ReactNode;
  component?: "button" | "link";
  colour?: "black";
  className?: string;
  disabled?: boolean;
  target?: string;
};

const ButtonBack = React.forwardRef<HTMLButtonElement, ButtonBackProps>(
  (
    {
      children,
      component = "button",
      href,
      colour = "black",
      className,
      ...props
    },
    ref
  ) => {
    return (
      <IconButton
        ref={ref}
        component={component}
        href={href}
        className={className}
        label={children}
        {...props}
        color={colour}
      >
        <span data-testid={"buttonBack__icon-container"}>
          <BackArrowIcon />
        </span>
      </IconButton>
    );
  }
);

export default ButtonBack;
